export default function getCSRFToken() {
  const meta = document.querySelector('meta[name="csrf-token"]');
  const token = meta ? meta.getAttribute('content') : null;

  if (!token) {
    throw new Error('CSRF token not found in meta tag');
  }

  return { 'X-CSRF-Token': token };
}
